import * as React from 'react';

export const IconList: React.FC = ({}) => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15H8.00897C8.56126 15 9.00897 14.5523 9.00897 14C9.00897 13.4477 8.56126 13 8.00897 13H8Z'
			fill='#000000'
		/>
		<path
			d='M11.9955 13C11.4432 13 10.9955 13.4477 10.9955 14C10.9955 14.5523 11.4432 15 11.9955 15H12.0045C12.5568 15 13.0045 14.5523 13.0045 14C13.0045 13.4477 12.5568 13 12.0045 13H11.9955Z'
			fill='#000000'
		/>
		<path
			d='M14.991 14C14.991 13.4477 15.4387 13 15.991 13H16C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H15.991C15.4387 15 14.991 14.5523 14.991 14Z'
			fill='#000000'
		/>
		<path
			d='M8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19H8.00897C8.56126 19 9.00897 18.5523 9.00897 18C9.00897 17.4477 8.56126 17 8.00897 17H8Z'
			fill='#000000'
		/>
		<path
			d='M10.9955 18C10.9955 17.4477 11.4432 17 11.9955 17H12.0045C12.5568 17 13.0045 17.4477 13.0045 18C13.0045 18.5523 12.5568 19 12.0045 19H11.9955C11.4432 19 10.9955 18.5523 10.9955 18Z'
			fill='#000000'
		/>
		<path
			fill-rule='evenodd'
			clip-rule='evenodd'
			d='M8.375 2C8.58211 2 8.75 2.16722 8.75 2.37351V4H15.25V2.37351C15.25 2.16722 15.4179 2 15.625 2C15.8321 2 16 2.16722 16 2.37351V4H17C19.2091 4 21 5.79086 21 8V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V8C3 5.79086 4.79086 4 7 4H8V2.37351C8 2.16722 8.16789 2 8.375 2ZM15.25 4.75V6.62649C15.25 6.83278 15.4179 7 15.625 7C15.8321 7 16 6.83278 16 6.62649V4.75H17C18.7949 4.75 20.25 6.20507 20.25 8V9.625H3.75V8C3.75 6.20507 5.20507 4.75 7 4.75H8V6.62649C8 6.83278 8.16789 7 8.375 7C8.58211 7 8.75 6.83278 8.75 6.62649V4.75H15.25ZM3.75 18V10.375H20.25V18C20.25 19.7949 18.7949 21.25 17 21.25H7C5.20507 21.25 3.75 19.7949 3.75 18Z'
			fill='#000000'
		/>
	</svg>
);
